



































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import mixin from './mixin'
import { Base64 } from 'js-base64'

@Component({
	name: 'AddTaskWithParam',
})
export default class AddTaskWithParam extends Mixins(mixin) {
	private param: any = ''

	public created() {
		this.setParam()
	}

	private activated() {
		this.setParam()
	}

	private setParam() {
		// this.param = {
		// 	businessId: 'aaa',
		// 	companyId: 'aaa',
		// 	subordinateCode: 'aaa',
		// 	caseNo: 'aaa',
		// 	ownerName: 'aaa',
		// 	ownerPhone: 'aaa',
		// 	carNo: 'aaa',
		// 	provinceCode: 'aaa',
		// 	cityCode: 'aaa',
		// 	countryCode: 'aaa',
		// 	hospital: 'aaa',
		// 	contact: 'aaa',
		// 	contactPhone: 'aaa',
		// 	department: 'aaa',
		// 	injuredName: 'aaa',
		// 	injuredPhone: '13111111111,13222222222,13333333333',
		// 	visitRequest: 'aaa',
		// }

		if (this.$route.query.param) {
			const obj = JSON.parse(Base64.decode(this.$route.query.param as any))
			this.param = obj
		} else if (this.$route.params.param) {
			// 通过$router.push传的params,只能获取一次,这样切换tab已修改的信息就不会被覆盖了
			this.param = this.$route.params.param // 还用不上
		}
	}
}
